<template>
  <div class="pos-detail">

    <div>
      <button
        class="buto"
        @click="toBack()"
      >返回所有营期</button>
      <van-cell-group
        class="fields"
        style="display: inline-block;width:30%;margin-left: 10px;"
      >
        <van-field
          style="border-radius:10px;padding: 5px 15px;"
          placeholder="拼音搜索"
          @click="skipSeach()"
        />
      </van-cell-group>
      <button
        class="buttons "
        style="color:#000;background-color: #fff;border:1px solid #000;float: right;"
        @click="skipGrouping()"
      >异常列表</button>
    </div>

    <div
      style="padding-top:10px"
      v-show="birthday_info"
    >
      <van-notice-bar
        wrapable
        :scrollable="false"
        :text="birthday_info"
      />
    </div>

    <div
      v-if="List!=null&&team_st ==0"
      style="margin-top:10px"
    >
      <div
        class="css-display"
        v-for="(item,index) in List"
        :key="index"
      >
        <div>
          <span style="font-weight: 700;font-size: 17px;">{{item.business_name}}</span>
          <span style="font-weight: 700;font-size: 15px;"> ({{item.ct}}人)</span>
        </div>

        <van-row class="box-content">
          <van-col span="2">序号</van-col>
          <!-- <van-col span="5">队伍</van-col> -->
          <van-col span="5">姓名</van-col>
          <van-col span="3">性别</van-col>
          <van-col span="8">电话</van-col>
        </van-row>

        <div
          v-for="(item2,index2) in item.list"
          :key="index2"
        >
          <van-row class="box-content">
            <van-col span="2">{{index2+1}}</van-col>
            <van-col span="5">{{item2.real_name}}</van-col>
            <van-col span="3">{{item2.sex=='man'?'男':'女'}}</van-col>
            <van-col span="8">{{item2.mobile_no||'暂无电话'}}</van-col>
          </van-row>
        </div>
      </div>
    </div>

    <div v-if="List!=null&&team_st ==1">
      <div v-if="List&&List.length>0">

        <div class="titleb">
          <div>{{info.party_title}}</div>
          <div v-if="info.date_start||info.date_end">{{info.date_start}} - {{info.date_end}}</div>
        </div>

        <div
          v-for="(item,index) in List"
          :key="index"
        >
          <div style="padding:15px 0;font-size:15px;font-weight:700">
            <span style="margin-right:10px;">{{item.name}}</span>
            <span>{{item.captain_name||'暂无队长'}}</span>
            <span
              style="margin-left:10px;color:#ee0a24"
              @click="onMobile(item.captain_mobile)"
            >{{item.captain_mobile||'暂无手机号'}}</span>
            <span style="margin-left:10px;">总计 <span style="color:#ee0a24">{{item.member_ct}}人</span></span>
            <span style="margin-left:10px;">实到 <span style="color:#ee0a24">{{item.actual_num}}</span>人</span>
          </div>

          <div
            v-for="(item2,index2) in item.business_info"
            :key="index2"
          >
            <div class="p10-size14">
              <div
                class="title-s"
                v-if="item2.business_name"
              >{{item2.business_name}}</div>
              <div
                class="value-s"
                v-if="item2.ct"
              >{{item2.ct}}人 </div>
              <div
                class="value-s"
                v-if="item2.salesman"
              >{{item2.salesman}}</div>
            </div>
          </div>
          <div style="padding:13px 0;">
            <button
              class="buto"
              style="background-color:yellow;color:black;border:0.5px solid black"
              @click="skipPath(item)"
            >查看名单</button>
          </div>
        </div>

      </div>
      <div
        v-else
        class="padding-top"
      >
        <van-empty description="暂无队伍信息" />
      </div>
    </div>
    <!-- <myFoot></myFoot> -->
    <!-- 占位 -->
    <div style="height: 40px;width: 100%;"></div>

    <div class="footers">
      <button
        class="buttons cwbf"
        style="width:30%;background-color: aqua;"
        @click="skipPhysicalState()"
      >体温/排便</button>

      <button
        class="buttons cwbf"
        style="width:30%;background-color:coral;"
        @click="skipWork()"
      >工作人员</button>
      <button
        class="buttons cwbf"
        style="width:30%;background-color:deepskyblue;"
        @click="skipTeam()"
      >管理</button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      project_id: '',
      List: null,
      info: {
        party_title: '',
        date_end: '',
        date_start: '',
      },
      birthday_info: '',
      team_st: null,
    }
  },
  created() {
    this.project_id = this.$route.query.project_id
    this.getListInfo()
  },
  methods: {
    getListInfo() {
      this.$axios
        .get(`/project/teamlist2`, {
          params: {
            project_id: this.project_id,
          },
        })
        .then((res) => {
          if (res.data.code == 400) {
            this.$router.replace({
              path: '/errorPage',
              query: { msg: res.data.msg },
            })
            return
          }
          if (res.data.code == 201) {
            let team_type = res.data.team_type
            let team_id = res.data.team_id
            switch (team_type) {
              case 2:
                this.$router.push({
                  path: '/lochus',
                  query: {
                    project_id: this.project_id,
                    team2_id: team_id,
                  },
                })
                break
              case 3:
                this.$router.push({
                  path: '/camper',
                  query: {
                    project_id: this.project_id,
                    team3_id: team_id,
                  },
                })
                break
            }

            console.log(res.data, '201返回')
            return
          }
          this.team_st = res.data.team_st
          if (res.data.team_st == 1) {
            let data = res.data.data
            let info = data.info
            this.List = data.teams
            this.birthday_info = data.birthday_info
            if (info.date_end) {
              info.date_end = this.$mUtil.format(info.date_end)
            }
            if (info.date_start) {
              info.date_start = this.$mUtil.format(info.date_start)
            }
            this.info = info
            let config = {
              title: `【${this.info.date_start}】${this.info.party_title}`,
              img: 'https://img.jiarixiaodui.com/jrhb-logo.jpg',
              sharePath: `/posDetail?project_id=${this.project_id}`,
            }
            this.wxShare(config)
          } else if (res.data.team_st == 0) {
            this.List = res.data.data
            console.log(this.List)
          }
        })
    },
    skipPath(item) {
      console.log(item)
      this.$router.push({
        path: '/lochus',
        query: {
          team2_id: item.id,
          project_id: this.project_id,
        },
      })
    },
    skipSeach() {
      this.$router.push({
        path: '/posSeach',
        query: {
          project_id: this.project_id,
        },
      })
    },
    skipGrouping() {
      this.$router.push({
        path: '/abnormalSearch',
        query: {
          project_id: this.project_id,
        },
      })
    },
    onMobile(phoneNumber) {
      console.log(phoneNumber, '手机号')
      if (phoneNumber) {
        window.location.href = 'tel://' + phoneNumber
      }
    },
    skipWork() {
      this.$router.push({
        path: '/work',
        query: {
          project_id: this.project_id,
        },
      })
    },
    skipPhysicalState() {
      this.$router.push({
        path: '/physicalState',
        query: {
          project_id: this.project_id,
        },
      })
    },

    toBack() {
      this.$router.push({
        path: '/Position',
      })
    },
    skipTeam() {
      this.$router.push({
        path: '/teamControl',
        query: {
          project_id: this.project_id,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.titleb {
  padding: 10px 0 0;
  line-height: 25px;
  font-size: 16px;
  font-weight: 700;
}
.pos-detail {
  padding: 20px;

  .buto {
    background-color: #ee0a24;
    color: #fff;
    padding: 10px 20px;
    border: none;
    border-radius: 6px;
  }
  .fields {
    display: inline-block;
    width: 40%;
    margin-left: 10px;
    border: 0.5px solid dodgerblue;
    border-radius: 5px;
  }

  .p10-size14 {
    padding: 5px 0;
    font-size: 14px;

    .title-s {
      display: inline-block;
      // width: 35%;
      font-weight: 500;
    }

    .value-s {
      margin-left: 5px;
      display: inline-block;
    }
  }
}
.buttons {
  color: #fff;
  padding: 9px 20px;
  border: none;
  border-radius: 6px;
}
.footers {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  font-weight: 700;
  background-color: #fff;
}
.cwbf {
  color: #000;
  border: 1px solid #000;
}
.css-display {
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #f1f1f1;
  padding: 10px;
  font-size: 15px;
  border-radius: 10px;
  box-shadow: 2px 2px 4px rgba($color: #4c4d47, $alpha: 0.5);
  margin-bottom: 10px;
}
.box-content {
  text-align: center;
  margin-top: 5px;
  font-size: 12px;
  height: 20px;
  line-height: 20px;
}
</style>